import { PosIconProps, SvgWrapper } from 'src/svgs/SvgWrapper';

export function SignoutIcon(props: PosIconProps) {
  return (
    <SvgWrapper viewBox="0 0 15 16" fill="currentColor" {...props}>
      <path d="M5.714 12.857q0 .036.009.179t.004.237-.027.21-.089.174-.183.058H2.571q-1.063 0-1.817-.754T0 11.144V4.858q0-1.063.754-1.817t1.817-.754h2.857q.116 0 .201.085t.085.201q0 .036.009.179t.004.237-.027.21-.089.174-.183.058H2.571q-.589 0-1.009.42t-.42 1.009v6.286q0 .589.42 1.009t1.009.42h2.786l.103.009.103.027.071.049.063.08.018.121zM14 8q0 .232-.17.402l-4.857 4.857q-.17.17-.402.17t-.402-.17-.17-.402v-2.571h-4q-.232 0-.402-.17t-.17-.402V6.285q0-.232.17-.402t.402-.17h4V3.142q0-.232.17-.402t.402-.17.402.17l4.857 4.857q.17.17.17.402z" />
    </SvgWrapper>
  );
}
